<template>
  <v-dialog
    v-model="dialog"
    content-class="v-dialog--custom"
    width="80%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <user-select
                  v-model="form.employee"
                  label="Employee"
                  :error-messages="[].concat(fieldErrors('form.employee'))"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="form.startLatitude"
                  label="Start Latitude"
                  :error-messages="[].concat(fieldErrors('form.startLatitude'))"
                  @blur="$v.form.startLatitude.$touch()"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="form.startLongitude"
                  label="Start Longitude"
                  :error-messages="[].concat(fieldErrors('form.startLongitude'))"
                  @blur="$v.form.startLongitude.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model="form.stopLatitude"
                  label="Stop Latitude"
                  :error-messages="[].concat(fieldErrors('form.stopLatitude'))"
                  @blur="$v.form.stopLatitude.$touch()"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="form.stopLongitude"
                  label="Stop Longitude"
                  :error-messages="[].concat(fieldErrors('form.stopLongitude'))"
                  @blur="$v.form.stopLongitude.$touch()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12"> Start Time </v-col>
              <v-col>
                <DatePicker
                  v-model="form.dateStart"
                  :errorMessages="[].concat(fieldErrors('form.dateStart'))"
                  :hideDetails="[].concat(fieldErrors('form.dateStart')).length == 0"
                  @onClear="validateStartTime()"
                  @blur="validateStartTime()"
                  @input="validateStartTime()"
                ></DatePicker>
              </v-col>
              <v-col>
                <TimePicker
                  v-model="form.timeStart"
                  format="ampm"
                  use-seconds
                  :errorMessages="[].concat(fieldErrors('form.timeStart'))"
                  :hideDetails="[].concat(fieldErrors('form.timeStart')).length == 0"
                  @onClear="validateStartTime()"
                  @blur="validateStartTime()"
                  @input="validateStartTime()"
                  fullyClear
                ></TimePicker>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12"> End Time </v-col>
              <v-col>
                <DatePicker
                  v-model="form.dateEnd"
                  :errorMessages="[].concat(fieldErrors('form.dateEnd'))"
                  :hideDetails="[].concat(fieldErrors('form.dateEnd')).length == 0"
                  @onClear="validateEndTime()"
                  @blur="validateEndTime()"
                  @input="validateEndTime()"
                ></DatePicker>
              </v-col>
              <v-col>
                <TimePicker
                  v-model="form.timeEnd"
                  format="ampm"
                  use-seconds
                  :errorMessages="[].concat(fieldErrors('form.timeEnd'))"
                  :hideDetails="[].concat(fieldErrors('form.timeEnd')).length == 0"
                  @onClear="validateEndTime()"
                  @blur="validateEndTime()"
                  @input="validateEndTime()"
                  fullyClear
                ></TimePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <h4>
                  Total Duration: {{ totalDuration | formatTimeRoundupSecond }}
                </h4>
              </v-col>
            </v-row>
            <v-row v-show="!isRunning">
              <v-col cols="12">
                <span>
                <span>20 min break taken?</span>
                <v-radio-group
                  row
                  v-model="qForm.q1"
                  @blur="$v.qForm.q1.$touch()"
                >
                  <v-radio label="Yes" value="yes"></v-radio>
                  <v-radio label="No" value="no"></v-radio>
                </v-radio-group>
                </span>
                <div v-show="qForm.q1 == 'no'">
                  <v-textarea
                    label="Explanation *"
                    rows="3"
                    v-model="qForm.explain1"
                    @blur="$v.qForm.explain1.$touch()"
                    :error-messages="[].concat(fieldErrors('qForm.explain1'))"
                    :hide-details="[].concat(fieldErrors('qForm.explain1')).length == 0"
                  ></v-textarea>
                  <br>
                </div>
              </v-col>
              <v-col cols="12">
                <span>
                <span>30 min lunch break taken?</span>
                <v-radio-group
                  row
                  v-model="qForm.q2"
                  @blur="$v.qForm.q2.$touch()"
                >
                  <v-radio label="Yes" value="yes"></v-radio>
                  <v-radio label="No" value="no"></v-radio>
                </v-radio-group>
                </span>
                <div v-show="qForm.q2 == 'no'">
                  <v-textarea
                    label="Explanation *"
                    rows="3"
                    v-model="qForm.explain2"
                    @blur="$v.qForm.explain2.$touch()"
                    :error-messages="[].concat(fieldErrors('qForm.explain2'))"
                    :hide-details="[].concat(fieldErrors('qForm.explain2')).length == 0"
                  ></v-textarea>
                  <br>
                </div>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="qForm.notes" :rows="3" label="Notes"/>
              </v-col>
              <v-col cols="12">
                <v-tabs
                  next-icon="mdi-arrow-right-bold-box-outline"
                  prev-icon="mdi-arrow-left-bold-box-outline"
                  show-arrows
                  v-model="tabs"
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab
                    v-for="(changeOrder, changeOrderIdx) in changeOrderReversed"
                    :key="`${changeOrderIdx}_changeOrders_tab`"
                    :href="'#tab-' + changeOrderIdx"
                  >
                    {{ changeOrder.title }}
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tabs">
                  <v-tab-item
                    v-for="(changeOrder, changeOrderIdx) in changeOrderReversed"
                    :key="`${changeOrderIdx}_changeOrders_content`"
                    :value="'tab-' + changeOrderIdx"
                  >
                    <v-card>
                      <v-card-title>
                        {{ changeOrder.titleTab }}
                      </v-card-title>
                      <v-card-text>
                        <v-card
                          class="mt-2"
                          v-for="(material, materialIdx) in changeOrder.materials"
                          :key="`${changeOrderIdx}_${materialIdx}_materials`"
                        >
                          <v-card-text>
                            <v-row>
                              <v-col
                                cols="12"
                                xl="4"
                                lg="6"
                                md="4"
                                sm="12"
                              >
                                <v-text-field
                                  label="Material"
                                  v-model="material.materialName"
                                  :hide-details="true"
                                  readonly
                                >
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                xl="1"
                                lg="2"
                                md="3"
                                sm="6"
                              >
                                <v-text-field
                                  v-model="material.quantity"
                                  label="Amount of Footage"
                                  type="number"
                                  :min="0"
                                  :error-messages="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.quantity`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.quantity`
                                        ].join(''),
                                      )
                                    )
                                  "
                                  :hide-details="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.quantity`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.quantity`
                                        ].join(''),
                                      )
                                    ).length == 0
                                  "
                                  @blur="
                                    $v
                                    .changeOrderReversed
                                    .$each[changeOrderIdx]
                                    .materials
                                    .$each[materialIdx]
                                    .quantity
                                    .$touch()
                                  "
                                >
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                xl="1"
                                lg="2"
                                md="2"
                                sm="6"
                              >
                                <v-select
                                  v-model="material.unit"
                                  :items="['ft²', 'Lineal ft']"
                                  label="Footage Unit *"
                                  :hide-details="true"
                                  :error-messages="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.unit`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.unit`
                                        ].join(''),
                                      )
                                    )
                                  "
                                  @blur="
                                    $v
                                    .changeOrderReversed
                                    .$each[changeOrderIdx]
                                    .materials
                                    .$each[materialIdx]
                                    .unit
                                    .$touch()
                                  "
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                xl="1"
                                lg="2"
                                md="3"
                                sm="6"
                              >
                                <v-text-field
                                  label="Amount of Material"
                                  v-model="material.quantityPerCase"
                                  type="number"
                                  :min="0"
                                  :error-messages="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.quantityPerCase`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.quantityPerCase`
                                        ].join(''),
                                      )
                                    )
                                  "
                                  :hide-details="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.quantityPerCase`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.quantityPerCase`
                                        ].join(''),
                                      )
                                    ).length == 0
                                  "
                                  @blur="
                                    $v
                                    .changeOrderReversed
                                    .$each[changeOrderIdx]
                                    .materials
                                    .$each[materialIdx]
                                    .quantityPerCase
                                    .$touch()
                                  "
                                >
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                xl="1"
                                lg="3"
                                md="3"
                                sm="6"
                              >
                                <v-select
                                  v-model="material.case"
                                  :items="caseList"
                                  label="Case *"
                                  :hide-details="true"
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                xl="2"
                                lg="3"
                                md="4"
                                sm="6"
                                v-if="material.case === 'Custom'"
                              >
                                <v-text-field
                                  label="Custom Material Unit"
                                  v-model="material.caseCustom"
                                  :hide-details="true"
                                />
                              </v-col>

                              <v-col
                                cols="12"
                                xl="1"
                                lg="2"
                                md="2"
                                sm="3"
                              >
                                <v-text-field
                                  v-model.number="material.hours"
                                  label="Man Hours"
                                  type="number"
                                  :min="0"
                                  :error-messages="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.hours`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.hours`
                                        ].join(''),
                                      )
                                    )
                                  "
                                  :hide-details="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.hours`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.hours`
                                        ].join(''),
                                      )
                                    ).length == 0
                                  "
                                  @blur="
                                    $v
                                    .changeOrderReversed
                                    .$each[changeOrderIdx]
                                    .materials
                                    .$each[materialIdx]
                                    .hours
                                    .$touch()
                                  "
                                />
                              </v-col>

                              <v-col
                                cols="12"
                                xl="1"
                                lg="2"
                                md="2"
                                sm="3"
                              >
                                <v-text-field
                                  v-model.number="material.minutes"
                                  label="Minutes"
                                  type="number"
                                  :min="0"
                                  :max="59"
                                  :error-messages="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.minutes`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.minutes`
                                        ].join(''),
                                      )
                                    )
                                  "
                                  :hide-details="
                                    [].concat(
                                      fieldErrors(
                                        [
                                          `changeOrderReversed`,
                                          `.$each[${changeOrderIdx}]`,
                                          `.materials`,
                                          `.$each[${materialIdx}]`,
                                          `.minutes`
                                        ].join(''),
                                        [
                                          `changeOrderReversed`,
                                          `.$each`,
                                          `.materials`,
                                          `.$each`,
                                          `.minutes`
                                        ].join(''),
                                      )
                                    ).length == 0
                                  "
                                  @blur="
                                    $v
                                    .changeOrderReversed
                                    .$each[changeOrderIdx]
                                    .materials
                                    .$each[materialIdx]
                                    .minutes
                                    .$touch()
                                  "
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
                <v-alert
                  type="info"
                  dense
                  outlined
                  text
                  class="mx-3"
                >
                  Total Manual Time should match Total Work Time
                </v-alert>
                <table width="100%">
                  <tr>
                    <td class="text-right">
                      <div class="pr-3">
                        Total Time Clock:
                        <v-chip small
                          >{{ totalTimeClock | formatTimeRoundupSecond }}
                        </v-chip>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-right">
                      <div class="pr-3">
                        Total Out Time:
                        <v-chip small
                          >{{ totalOutTime | formatTimeRoundupSecond }}
                        </v-chip>
                      </div>
                    </td>
                  </tr>

                  <tr><td class="py-2">&nbsp;</td></tr>

                  <tr>
                    <td class="text-right">
                      <div class="pr-3">
                        Total Work Time:
                        <v-chip small
                          >{{ totalWorkTime | formatTimeRoundupSecond }}
                        </v-chip>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-right">
                      <div class="pr-3">
                        Total Manual Time:
                        <v-chip :color="matchColor" small
                          >{{ totalManualTime | formatTimeRoundupSecond }}
                        </v-chip>
                      </div>
                    </td>
                  </tr>

                  <tr v-if="matchColor === 'error'">
                    <td class="text-right" style="color: red">
                      <div class="pr-3">
                        Total Manual Time does not match Total Work Time
                      </div>
                    </td>
                  </tr>
                  
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid || matchColor === 'error'"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import moment from "moment";
import DatePicker from "components/DatePicker";
import TimePicker from "components/TimePicker";
import UserSelect from "src/components/UserSelect";
import { roundupSeconds, roundSecondsQuarterHour } from "src/utils/helpers";

const defaultInputs = {
  startTime: "",
  stopTime: "",
  startLongitude: "0",
  startLatitude: "0",
  stopLongitude: "0",
  stopLatitude: "0",
  employee: [],
  dateStart: moment(new Date()).format("YYYY-MM-DD"),
  timeStart: moment(new Date()).format("HH:mm"),
  dateEnd: moment(new Date()).format("YYYY-MM-DD"),
  timeEnd: moment(new Date()).format("HH:mm"),
};

const defaultQForm = {
  q1: "",
  q2: "",
  explain1: "",
  explain2: "",
  notes: ""
};

const minDate = (value, siblings) => {
  const dS = siblings.dateStart ? moment(siblings.dateStart).utc() : null;
  const dE = value ? moment(value).utc() : null;

  if(dS && dE) {
    return dE.isSame(dS) || dE.isAfter(dS);
  } else {
    return true;
  }
}

const minTime = (value, siblings) => {
  const dS = siblings.dateStart;
  const dE = siblings.dateEnd;
  const tS = siblings.timeStart;
  const tE = value;
  const sameDay = dS && dE ? moment(dS).isSame(moment(dE)) : false;

  if(sameDay && tS && tE) {
    const start = moment(`${dS} ${tS}`);
    const end = moment(`${dE} ${tE}`);
    return end.isAfter(start);
  } else {
    return true;
  }
}

export default {
  components: {
    AlertMessage,
    DatePicker,
    TimePicker,
    UserSelect,
  },
  props: {
    clientId: Number,
    parentItem: Object,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations() {
    if(this.isRunning) {
      return {
        form: {
          employee: {
            required,
          },
          startLatitude: {},
          startLongitude: {},
          stopLatitude: {},
          stopLongitude: {},
          dateStart: {
            required,
          },
          timeStart: {
            required,
          },
          dateEnd: {
            required: requiredIf(function() {
              return !!this.form.timeEnd;
            }),
            minDate: minDate,
          },
          timeEnd: {
            required: requiredIf(function() {
              return !!this.form.dateEnd;
            }),
            minTime: minTime,
          },
        },
        qForm: {
          q1: { },
          q2: { },
          explain1: {},
          explain2: {},
        },
        changeOrderReversed: {
          $each: {
            materials: {
              $each: {
                taskId: {},
                changeOrderId: {},
                materialName: {},
                quantity: {},
                quantityPerCase: {},
                case: {},
                caseCustom: {},
                unit: {},
                hours: {},
                minutes: {},
              },
            },
          },
        },
      }
    } else {
      return {
        form: {
          employee: {
            required,
          },
          startLatitude: {},
          startLongitude: {},
          stopLatitude: {},
          stopLongitude: {},
          dateStart: {
            required,
          },
          timeStart: {
            required,
          },
          dateEnd: {
            required: requiredIf(function() {
              return !!this.form.timeEnd;
            }),
            minDate: minDate
          },
          timeEnd: {
            required: requiredIf(function() {
              return !!this.form.dateEnd;
            }),
            minTime: minTime,
          },
        },
        qForm: {
          q1: { required },
          q2: { required },
          explain1: {
            required: requiredIf(function() {
              return this.qForm.q1 === "no";
            }),
          },
          explain2: {
            required: requiredIf(function() {
              return this.qForm.q2 === "no";
            }),
          },
        },
        changeOrderReversed: {
          $each: {
            materials: {
              $each: {
                taskId: {},
                changeOrderId: {},
                materialName: {},
                quantity: {
                  minValue: minValue(0),
                },
                quantityPerCase: {
                  minValue: minValue(0),
                },
                case: { required },
                caseCustom: {},
                unit: { required },
                hours: {
                  minValue: minValue(0),
                },
                minutes: {
                  minValue: minValue(0),
                },
              },
            },
          },
        },
      }
    }
  },
  validationMessages: {
    form: {
      employee: {
        required: "Required",
      },
      startLongitude: {
        required: "Required",
      },
      startLatitude: {
        required: "Required",
      },
      stopLongitude: {
        
      },
      stopLatitude: {
        
      },
      dateStart: {
        required: "Required",
      },
      timeStart: {
        required: "Required",
      },
      dateEnd: {
        required: "Required when end time provided",
        minDate: "Cannot precede start date"
      },
      timeEnd: {
        required: "Required when end date provided",
        minTime: "Cannot precede start time"
      },
    },
    qForm: {
      q1: { required: "Required" },
      q2: { required: "Required" },
      explain1: { required: "Required" },
      explain2: { required: "Required" },
    },
    changeOrderReversed: {
      $each: {
        materials: {
          $each: {
            taskId: {},
            changeOrderId: {},
            materialName: {},
            quantity: {
              minValue: "Must be 0 or greater"
            },
            quantityPerCase: {
              minValue: "Must be 0 or greater"
            },
            case: { required: "Required" },
            caseCustom: {},
            unit: { required: "Required" },
            hours: {
              minValue: "Must be 0 or greater"
            },
            minutes: {
              minValue: "Must be 0 or greater"
            },
          },
        },
      },
    },
  },

  data() {
    return {
      showDialog: this.show,
      showEdit: false,
      showDelete: false,
      form: {
        ...defaultInputs,
      },
      qForm: {
        ...defaultQForm,
      },
      changeOrders: [],
      tabs: "",
      caseList: ["Case", "Custom", "Gallon", "Roll", "Sausage", "Tube"],
      dialog: false,
      valid: false,
      loading: false,
      
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      timeclock: (state) => state.timeclock,
      alert: (state) => state.alert,
    }),

    totalDuration() {
      if(this.startUtc && this.endUtc) {
        return parseInt(Math.abs(this.endUtc.diff(this.startUtc, "second")));
      } else if (this.startUtc) {
        const curTime = moment().utc();
        return parseInt(Math.abs(curTime.diff(this.startUtc, "second")));
      } else {
        return 0;
      }
    },

    startUtc() {
      let startUtc = null;
      if(this.form.dateStart && this.form.timeStart) {
        startUtc = moment(`${this.form.dateStart} ${this.form.timeStart}`).utc();
      } else if(this.form.dateStart) {
        startUtc = moment(this.form.dateStart).startOf("day").utc();
      } else if(this.form.timeStart) {
        const seconds = moment.duration(this.form.timeStart).asSeconds();
        startUtc = moment().startOf("day").add(seconds, "seconds").utc();
      }
      return startUtc;
    },

    endUtc() {
      let endUtc = null;
      if(this.form.dateEnd && this.form.timeEnd) {
        endUtc = moment(`${this.form.dateEnd} ${this.form.timeEnd}`).utc();
      } else if(this.form.dateEnd) {
        endUtc = moment(this.form.dateEnd).startOf("day").utc();
      } else if(this.form.timeEnd) {
        const seconds = moment.duration(this.form.timeEnd).asSeconds();
        endUtc = moment().startOf("day").add(seconds, "seconds").utc();
      }
      return endUtc;
    },

    formTitle() {
      return this.isEdit
        ? `Edit Time Entry #${this.item.id}`
        : "Add Time Entry";
    },

    isRunning() {
      return !this.form.dateEnd;
    },

    isEdit() {
      return this.optional(this.item, "id", "") ? true : false;
    },

    timeclockId() {
      return this.optional(this.item, "id", "");
    },

    questionnaireId() {
      return this.optional(this.item, "id", "");
    },

    entries() {
      let entries = this.optional(this.item, "timeClockEntries", []) || [];
      return entries.map((entry) => {
        return {
          ...this.formatEntry(entry),
        };
      });
    },

    changeOrderReversed() {
      return [...this.changeOrders];
    },

    matchColor() {
      if (this.totalManualTime === this.totalWorkTime) {
        return "success";
      } else {
        return "error";
      }
    },

    totalOutTime() {
      let totalOutTime = 0;
      if(this.qForm.q2 === "yes") {
        totalOutTime += 30 * 60; // 30 mins
      }
      return totalOutTime;
    },

    totalTimeClock() {
      const totalTimeClock = this.sumTimeClockEntries([{
        ...this.item,
        startTime: this.localToUtc(`${this.form.dateStart} ${this.form.timeStart}`),
        stopTime: this.localToUtc(`${this.form.dateEnd} ${this.form.timeEnd}`),
      }]);
      const roundedTotalTimeClock = roundSecondsQuarterHour(roundupSeconds(totalTimeClock));
      return roundedTotalTimeClock;
    },

    totalWorkTime() {
      return this.totalTimeClock - this.totalOutTime;
    },

    totalManualTime() {
      let totalManualTime = 0;
      this.changeOrderReversed.map((co) => {
        co.materials.map((mt) => {
          let hour = mt.hours ? mt.hours : 0;
          let minute = mt.minutes ? mt.minutes : 0;
          totalManualTime += parseFloat(hour * 3600) + parseFloat(minute * 60);
        });
      });
      return totalManualTime;
    },
  },

  methods: {
    ...mapActions({
      timeclockEntryCreate: "timeclockEntry/create",
      timeclockEntryUpdate: "timeclockEntry/update",
    }),
    onEdit(item) {
      this.showEdit = true;
      this.selectedItem = item;
    },
    onDelete(item) {
      this.showDelete = true;
      this.selectedItem = item;
    },

    setMap() {},

    validateStartTime() {
      this.$nextTick(() => {
        this.$v.form.dateStart.$touch();
        this.$v.form.timeStart.$touch();
      })
    },

    validateEndTime() {
      this.$nextTick(() => {
        this.$v.form.dateEnd.$touch();
        this.$v.form.timeEnd.$touch();
      })
    },

    formatEntry(entry) {
      let dateStart = this.momentLocal(entry.startTime).format("YYYY-MM-DD");
      let timeStart = this.momentLocal(entry.startTime).format("HH:mm");
      let dateEnd = this.momentLocal(entry.stopTime).format("YYYY-MM-DD");
      let timeEnd = this.momentLocal(entry.stopTime).format("HH:mm");
      return {
        ...entry,
        dateStart: dateStart,
        timeStart: timeStart,
        dateEnd: dateEnd,
        timeEnd: timeEnd,
      };
    },

    formatQuestionnaireEntry(entry) {
      let q1 = "";
      if (entry?.questionnaire?.question1answer === true) {
        q1 = "yes";
      } else if(entry?.questionnaire?.question1answer === false) {
        q1 = "no";
      }
      let q2 = "";
      if (entry?.questionnaire?.question2answer === true) {
        q2 = "yes";
      } else if(entry?.questionnaire?.question2answer === false) {
        q2 = "no";
      }
      let explain1 = entry?.questionnaire?.question1reason || "";
      let explain2 = entry?.questionnaire?.question2reason || "";
      let notes = entry?.questionnaire?.notes || "";

      return {
        ...entry,
        q1: q1,
        q2: q2,
        explain1: explain1,
        explain2: explain2,
        notes: notes,
      }
    },

    initForm() {
      if (this.clientId) {
        this.form = {
          ...defaultInputs,
          ...this.formatEntry(this.item),
          clientId: this.clientId,
        };
      } else {
        this.form = {
          ...defaultInputs,
          ...this.formatEntry(this.item),
        };
      }
      this.qForm = {
        ...defaultQForm,
        ...this.formatQuestionnaireEntry(this.item),
      };
      this.setMap();

      let jobMaterials = this.parentItem?.jobMaterials || [];
      // parse changeOrder here
      let changeOrders = [
        ...new Set(jobMaterials.map((obj) => obj.changeOrderId)),
      ];
      this.changeOrders = changeOrders.map((changeOrderIdx) => {
        let materials = jobMaterials
          .filter((m) => m.changeOrderId == changeOrderIdx)
          .map((material) => {
            const usedMaterial = this.item?.jobMaterialsUsed?.find((x) => {
              return x?.materialName && x?.materialName === material?.materialName && material?.changeOrderId === x?.changeOrderId;
            });

            const materialCase = usedMaterial?.case || material.case;
            const caseFinal = !this.caseList.includes(materialCase)
              ? "Custom"
              : materialCase;
            const caseFinalCustom = caseFinal === "Custom" ? materialCase : "";
            
            const seconds = Number(usedMaterial?.seconds) || 0;
            const hours = Math.floor(seconds/3600);
            const minutes = Math.floor(seconds % 3600 / 60);

            return {
              ...material,
              case: caseFinal,
              caseCustom: caseFinalCustom,
              seconds: seconds,
              hours: hours,
              minutes: minutes,
              quantity: usedMaterial?.quantity || 0,
              quantityPerCase: usedMaterial?.quantityPerCase || 0,
            };
          });

          const title = materials[0]?.changeOrderName || "Change Order";

          return {
          id: changeOrderIdx,
          title: title,
          titleTab: title,
          // titleTab:
          //   changeOrderIdx == 1
          //     ? "Original Quote"
          //     : `Change Order #${changeOrderIdx - 1}`,
          // materials: [...materials],
          materials,
        };
      });

      // sort by change order id, to keep original quote and additional quote tab position
      this.changeOrders.sort(function (a, b) {
        return a.id - b.id;
      });
    },

    serverSideErrors(field) {
      return this.optional(this.timeclock.errors, field, []);
    },
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });

      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
          dateStart: moment(new Date()).format("YYYY-MM-DD"),
          timeStart: moment(new Date()).format("HH:mm"),
          dateEnd: moment(new Date()).format("YYYY-MM-DD"),
          timeEnd: moment(new Date()).format("HH:mm"),
      };
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let jobMaterialsUsed = [];

      this.changeOrderReversed.map((changeOrders) => {
        changeOrders.materials.map((material) => {
          // if (!this.isEdit) {
          //   delete material.id;
          // }
          let materialId = this.isEdit || material.id; 
          let totalHoursInSeconds = parseInt(material?.hours || 0) * 3600;
          let totalMinutesInSeconds = parseInt(material?.minutes  || 0) * 60;

          let caseFinal = material.case == "Custom"
            ? material.caseCustom
            : material.case;
          let payloadMaterial = {
            ...material,
            id: materialId,
            case: caseFinal,
            quantity: material?.quantity || 0,
            quantityPerCase: material?.quantityPerCase || 0,
            seconds: totalHoursInSeconds + totalMinutesInSeconds,
            questionnaireAnswersId: this.form?.questionnaire?.id || undefined,
            questionnaireAnswers: null,
          };
          delete payloadMaterial.id;
          delete payloadMaterial.hours;
          delete payloadMaterial.minutes;

          jobMaterialsUsed.push(payloadMaterial);
        });
      });
      let payload = {
        ...this.form,
        startTime: this.localToUtc(`${this.form.dateStart} ${this.form.timeStart}`),
        stopTime: this.localToUtc(`${this.form.dateEnd} ${this.form.timeEnd}`),
        questionnaireAnswer: {
          id: this.form?.questionnaire?.id || undefined,
          userId: this.form.employee,
          timeClockId: this.item.id,
          timestamp: new Date(),
          question1answer: this.qForm.q1 === "yes",
          question1reason: this.qForm.q1 === "no" ? this.qForm.explain1 : "",
          question2answer: this.qForm.q2 === "yes",
          question2reason: this.qForm.q2 === "no" ? this.qForm.explain2 : "",
          notes: this.qForm.notes,
        },
        jobMaterialsUsed: jobMaterialsUsed,
      };

      delete payload.dateStart;
      delete payload.timeStart;
      delete payload.dateEnd;
      delete payload.timeEnd;
      delete payload.questionnaire;

      if (this.isEdit) {
        await this.timeclockEntryUpdate({
          id: this.timeclockId,
          ...payload,
        });
      } else {
        delete payload.id;
        await this.timeclockEntryCreate({
          taskId: this.item.timeclockId,
          ...payload,
        });
      }

      if (!this.timeclock.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>